import React from "react";
import "./App.css";
import About from "./components/about";
import Contact from "./components/contact";
import Introduction from "./components/introduction";
import Projects from "./components/projects";
import Sidebar from "./components/sidebar";
import Timeline from "./components/timeline";

function App() {
  return (
    <div id="colorlib-page">
      <div id="container-wrap">
        <Sidebar></Sidebar>
        <div id="colorlib-main">
          <Introduction></Introduction>
          <About></About>
          <Projects></Projects>
          <Timeline></Timeline>
          <Contact></Contact>
        </div>
      </div>
    </div>
  );
}

export default App;
